export default {
  deletePermission: '/auth/userPermission/deletePermission', //删除权限
  authValidity: '/auth/user/authValidity', //权限停用启用
  getPhoneEmail:'/auth/user/get-user-phone-and-email', //手机号脱敏
};
  


// WEBPACK FOOTER //
// ./src/api/authWorkbench.js